import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleRoadWorthyCheckRecordCategoryEnum } from '../enums/vehicle-road-worthy-check-record-category.enum';

/**
 * Create vehicle road worthy check DTO
 */
export class CreateVehicleRoadWorthyCheckDto {
  color?: string | null;
  externalReference?: string | null;
  @TransformDate()
  startsAt!: Date;
  @TransformDate()
  endsAt!: Date;
  notes?: string | null;
  recordCategory!: VehicleRoadWorthyCheckRecordCategoryEnum;
  @TransformInt()
  vehicleId!: number;
  @TransformInt()
  vehicleMaintenanceId?: number | null;
  taxRateType?: TaxRateTypeEnum | null;
  @TransformFloat()
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  @TransformFloat()
  amount?: number | null;
  @TransformFloat()
  totalNet?: number | null;
  @TransformFloat()
  totalTax?: number | null;
  @TransformFloat()
  totalGross?: number | null;
  tags?: TagDto[] | null;
  files?: FileDto[] | null;
}
